import { render, staticRenderFns } from "./feedBack_dynamic.vue?vue&type=template&id=3516d2aa&scoped=true"
import script from "./feedBack_dynamic.vue?vue&type=script&lang=js"
export * from "./feedBack_dynamic.vue?vue&type=script&lang=js"
import style0 from "./feedBack_dynamic.vue?vue&type=style&index=0&id=3516d2aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3516d2aa",
  null
  
)

export default component.exports